import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';

const useStyles = makeStyles({
  root: {
    margin: '24px 0',
    flexGrow: 1,
    '& .MuiInputBase-root': {
      height: '40px',
    },
  },
  inputList: {
    '& .MuiIconButton-root': {
      color: colors.black,
    },
  },
});

export default useStyles;
